module.exports = __webpack_public_path__ + "static/media/BrutalType-Bold.7d12e2ec.woff";